import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { dateToString, encodeBase64, handleGetCookie, checkPermissionByPath, FormatCurrencys } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import { callExportAgent, callExportLifeContractPDF } from "../../../api/export";
import { callCancelContract, callGetContractByKey } from "../../../api/contract/service";
import SmartTable from "../../../components/common/table-component";
import PermissionWrapper from "../../../components/common/PermissionWrapper";
import SwalAlert from "../../../components/common/alert";
import items from "../../../data/reportCustomer";

import { CREATE, EDIT, PRINT, DELETE, CLAME } from "../../../utils/commonType"
import { callGetAllProvince } from "../../../api/settings/service";
const Index = () => {
	const { pathname } = useLocation();
	let baseUrl = "/admin/callcenter/agentService/save";
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, insuranceType: 1, maxResult: 10, keyword: '', modifiedCode: '', modifiedName: '', provinceId: '', region: '', startYear: '2024', endYear: new Date().getFullYear() });
	const [contract, setContract] = useState({ totalPages: 0, totalRecords: 0, result: [] });
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(0);
	const location = useLocation();
	const [provinceList, setProvinceList] = useState([]);
	const [regionList, setregionList] = useState([]);

	useEffect(() => {
		loadData();
		loadProvince();
	}, [location.state, request.startYear, request.endYear]);
	const columns = [
		{ label: 'lifeContractNumber', key: 'id' },
		{ label: 'lifeContractFullName', style: { minWidth: '156px' }, key: 'fullName' },
		{ label: 'lifeContractAgentCode', style: { minWidth: '156px' }, key: 'agentCode' },
		{
			label: 'lifeContractStatus', key: 'status', render: (val) => (
				<span className={"badge " + (val === '1' ? "bg-success" : "bg-danger")}>{t('status.' + val)}</span>
			)
		},
		{
			label: 'lifeContractAgeRange', style: { minWidth: '50px' }, key: 'ageRange', render: (val) => (
				val ? val : '-'
			)
		},
		{
			label: 'lifeContractPayPerMonth', style: { minWidth: '50px' }, key: 'payPerMonth', render: (val) => (
				val ? FormatCurrencys(val) : '-'
			)
		},
		{
			label: 'lifeContractPhone', key: 'phone', render: (val) => (
				val ? val : '-'
			)
		},
		{
			label: 'lifeContractSignedDate', key: 'signedDate', render: (val) => (
				val ? dateToString(val) : '-'
			)
		},


	];


	const loadData = async (e) => {

		let data = { keyword: request.keyword, page: request.page, maxResult: request.maxResult, insuranceType: 1, provinceId: request.provinceId, region: request.region, startYear: request.startYear, endYear: request.endYear };
		if (e) {
			data = { ...request, ...e }
		}
		console.log(data)
		const rsp = await dispatch(callGetContractByKey(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setContract(rsp.payload.data)

		}

	}
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleEdit = (id) => {
		navigate(pathname + "/save/" + encodeBase64(id.contractNumber))
	}
	const handleClame = (id) => {
		navigate(pathname + "/clame/" + encodeBase64(id.contractNumber))
	}

	const handleDelete = (item) => {
		SwalAlert.confirm(t("titleDelete"), t("confirmDelete"), async () => {
			try {
				const rsp = await dispatch(callCancelContract({ contractNumber: item.contractNumber, insuranceType: 1 }));
				if (rsp?.payload?.responseCode === "00000") {
					SwalAlert.success(t("success.delete"), () => {
						loadData();
					});
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}

	const downloadExcel = async () => {
		try {
			let data = { contract: 'LTL_20250322151308' };
			let response = await callExportLifeContractPDF(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = `agent_${moment().format("YYYYMMDDHHmmss")}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.contractControl.lifeContractPaymentDetail")}</h4>

						<div className="group-button-header">
							{
								<PermissionWrapper permission={CREATE}>
									<button type="button" className="btn btn-primary" onClick={() => navigate(pathname + '/save')}>
										<i className="fas fa-plus"></i> {t("button.add")}
									</button>
								</PermissionWrapper>

							}

							{
								<PermissionWrapper permission={PRINT} >
									<button className="btn btn-success" onClick={downloadExcel}>
										<i className="fas fa-file-export"></i> {t("button.exportExcel")}
									</button>
								</PermissionWrapper>
							}

						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-4">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-4 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-4 form-group">
													<label>{t('search.region')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="region"
														value={request.region}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															items.region.map((item) => (
																<option key={item.key} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('search.startYear')}</label>
													<select
														className="form-select"
														name="startYear"
														value={request.startYear}
														onChange={handleChange}
													>
														{
															Array.from({ length: new Date().getFullYear() - 2008 }, (_, i) => {
																const year = 2016 + i;
																return (
																	<option key={year} value={year}>
																		{year}
																	</option>
																);
															})
														}
													</select>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('search.endYear')}</label>
													<select
														className="form-select"
														name="endYear"
														value={request.endYear}
														onChange={handleChange}
													>
														{
															Array.from({ length: new Date().getFullYear() - 2008 }, (_, i) => {
																const year = 2016 + i;
																return (
																	<option key={year} value={year}>
																		{year}
																	</option>
																);
															})
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={contract} keyword={request.keyword} onLazyLoad={loadData} startYear={request.startYear} endYear={request.endYear} colCheck="paidMonth"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
